import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './Features/Authentication';
import { Provider } from 'react-redux';
import { setupInterceptors, store } from 'Config';
import Scripts from './Scripts';
import { createRoot } from 'react-dom/client';
import 'tailwind.css';
import { applyPolyfills, defineCustomElements } from '@telekom/scale-components/loader';
import '@telekom/scale-components/dist/scale-components/scale-components.css';
import { ErrorBoundary } from '@appsignal/react';
import { appsignal } from './appsignal';

applyPolyfills().then(() => {
  defineCustomElements(window);
});

const FallbackComponent = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="text-center">
      <h1 className="mb-4 text-2xl font-bold">Something went wrong</h1>
      <p>We're sorry, but there was an error loading this page.</p>
    </div>
  </div>
);

setupInterceptors(store);
const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary instance={appsignal} action="AppEMedia" fallback={() => <FallbackComponent />}>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<AuthProvider App={App} />} />
          </Routes>
          <Scripts />
        </BrowserRouter>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
